import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { showErrors } from '../../modules/general';
import { apiFetch, apiSearch } from '../../modules/utility';

const apiBase = 'apProcessedEmail';

export const search = (p = {}) => {
	const { callback = _.noop, afterDate } = p;
	return (dispatch) => {
		apiSearch({
			base: apiBase,
			params: { afterDate },
			dispatch,
			callback,
		});
	};
};

export const get = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.get`,
			params,
			dispatch,
			callback,
		});
	};
};

const mapStateToProps = (state) => {
	let apProcessedEmails;
	if (state.lists.apProcessedEmailIds) {
		apProcessedEmails = _.map(
			state.lists.apProcessedEmailIds,
			(id) => state.maps.apProcessedEmail[id]
		);
	}

	return {
		apProcessedEmails,
		authUser: state.auth.authUser,
	};
};
const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			apProcessedEmailSearch: search,
			showErrors,
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps);
